import styled from '@emotion/styled'

import { palette, typography } from '../constants'

interface IProps {
  muted?: boolean
  preferredColor?: string
  fontSize?: number
}

function pickColor(props: IProps): string {
  const { muted, preferredColor } = props
  if (preferredColor) return preferredColor
  return muted ? palette.slate : palette.almostBlack
}

function setFontSize(props: IProps): string {
  const { fontSize } = props
  return fontSize ? `${fontSize}px` : `${typography.fontWeight.regular}`
}

export default styled.span<IProps>`
  color: ${props => pickColor(props)};
  font-family: ${typography.fontFamily.ui};
  font-size: ${props => setFontSize(props)};
  font-weight: ${typography.fontWeight.regular};
  line-height: 24px;

  // HACK (alex): cross-bundle compatibility
  text-transform: none;
`
